/**
 * Derives the campaign/schedule status to display from parent status + queueDetail.
 * When every occurrence failed, surface "failed" even if the API left parent as "complete".
 */
export const getEffectiveScheduleStatus = record => {
  if (!record) return undefined;

  const queues = record.queueDetail;
  if (Array.isArray(queues) && queues.length > 0) {
    const allFailed = queues.every(q => q?.queuestatus === "failed");
    if (allFailed) {
      return "failed";
    }
  }

  return record.status;
};
